<div class="login-page-wrapper" [class.sme-login]="isSMELogin">
  @if (showSSOErrorToast) {
    <div class="sso-error-toast" role="alert" aria-live="assertive">
      <div class="sso-toast-inner">
        <!-- Icon Badge -->
        <div class="sso-toast-icon-badge" aria-hidden="true">
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
              fill="currentColor"
              opacity="0.15"
            />
            <path
              d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <line
              x1="12"
              y1="9"
              x2="12"
              y2="13"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
            />
            <circle cx="12" cy="16.5" r="1" fill="currentColor" />
          </svg>
        </div>

        <!-- Text -->
        <div class="sso-toast-text">
          <p class="sso-toast-title">Authentication Error</p>
          <p class="sso-toast-message">
            The authentication method used is incorrect for this account. Please
            login using your <strong>email address</strong>.
          </p>
        </div>

        <!-- Close Button -->
        <button
          type="button"
          class="sso-toast-close"
          (click)="closeSSOErrorToast()"
          aria-label="Dismiss error"
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
    </div>
  }
  <div class="left-section">
    <div class="login-section">
      <div class="login-logo-section">
        <app-svg-icon
          [iconName]="'deeproots-logo-v2.svg'"
          [width]="'100%'"
        ></app-svg-icon>
      </div>

      @if (!isSignupMode) {
        <div class="login-button-wrapper">
          <a href="javascript:void(0)" (click)="logIn()" class="login-button">
            <span>Login</span>
          </a>
        </div>

        @if (isSMELogin) {
          <div class="signup-section">
            <div class="divider">
              <span>New to our platform?</span>
            </div>
            <button class="signup-button" (click)="toggleSignup()">
              Sign Up
            </button>
          </div>
        }
      } @else {
        <app-sme-signup (backToLogin)="toggleSignup()"></app-sme-signup>
      }
    </div>
  </div>
  <div class="right-section" [class.sme-right-section]="isSMELogin">
    @if (isSMELogin) {
      <!-- SME Login Right Section -->
      <div class="sme-content-wrapper">
        <div class="sme-hero">
          <h1 class="sme-hero-title">
            Grow Your Business with the Right Partners
          </h1>
          <p class="sme-hero-subtitle">
            Connect with mission-driven lenders who understand your vision and
            are ready to fuel your growth.
          </p>
        </div>

        <div class="sme-features">
          <div class="sme-feature-item">
            <div class="sme-feature-icon funding-icon">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19 14V6C19 4.9 18.1 4 17 4H3C1.9 4 1 4.9 1 6V14C1 15.1 1.9 16 3 16H17C18.1 16 19 15.1 19 14ZM10 13C7.79 13 6 11.21 6 9C6 6.79 7.79 5 10 5C12.21 5 14 6.79 14 9C14 11.21 12.21 13 10 13ZM23 7V18C23 19.1 22.1 20 21 20H4C4 18.9 4.9 18 6 18H21V7C22.1 7 23 7.9 23 7Z"
                  fill="currentColor"
                />
              </svg>
            </div>
            <div class="sme-feature-text">
              <h3>Submit Your Funding Needs</h3>
              <p>Share your business goals and capital requirements</p>
            </div>
          </div>

          <div class="sme-feature-item">
            <div class="sme-feature-icon connect-icon">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16 11C17.66 11 18.99 9.66 18.99 8C18.99 6.34 17.66 5 16 5C14.34 5 13 6.34 13 8C13 9.66 14.34 11 16 11ZM8 11C9.66 11 10.99 9.66 10.99 8C10.99 6.34 9.66 5 8 5C6.34 5 5 6.34 5 8C5 9.66 6.34 11 8 11ZM8 13C5.67 13 1 14.17 1 16.5V19H15V16.5C15 14.17 10.33 13 8 13ZM16 13C15.71 13 15.38 13.02 15.03 13.05C16.19 13.89 17 15.02 17 16.5V19H23V16.5C23 14.17 18.33 13 16 13Z"
                  fill="currentColor"
                />
              </svg>
            </div>
            <div class="sme-feature-text">
              <h3>Connect with Qualified Lenders</h3>
              <p>Access a network of CDFIs ready to support you</p>
            </div>
          </div>

          <div class="sme-feature-item">
            <div class="sme-feature-icon track-icon">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9 16.17L4.83 12L3.41 13.41L9 19L21 7L19.59 5.59L9 16.17Z"
                  fill="currentColor"
                />
              </svg>
            </div>
            <div class="sme-feature-text">
              <h3>Track Your Progress</h3>
              <p>Monitor applications and engagement in real-time</p>
            </div>
          </div>

          <div class="sme-feature-item">
            <div class="sme-feature-icon growth-icon">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16 6L18.29 8.29L13.41 13.17L9.41 9.17L2 16.59L3.41 18L9.41 12L13.41 16L19.71 9.71L22 12V6H16Z"
                  fill="currentColor"
                />
              </svg>
            </div>
            <div class="sme-feature-text">
              <h3>Access Growth Capital</h3>
              <p>Secure funding to scale and expand your business</p>
            </div>
          </div>
        </div>
      </div>
    } @else {
      <!-- Organization Login Right Section -->
      <svg
        width="402"
        height="393"
        viewBox="0 0 402 393"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M230 282.989H282.991V338H230V282.989Z"
          fill="#5597D4"
        />
        <path d="M78 328L82 337" stroke="#A4A4A4" />
        <path d="M88 317L99 337" stroke="#A4A4A4" />
        <path d="M99 330L103 337" stroke="#A4A4A4" />
        <path
          d="M35 94C35 94 49.937 81.19 66 99C82.063 116.81 91.937 103.19 94 89C96.063 74.81 125.937 56.19 120 79C114.063 101.81 80.937 80.19 99 61"
          stroke="#CCCCCC"
        />
        <path
          d="M80.5 276C81.8807 276 83 274.881 83 273.5C83 272.119 81.8807 271 80.5 271C79.1193 271 78 272.119 78 273.5C78 274.881 79.1193 276 80.5 276Z"
          stroke="#CCCCCC"
        />
        <path
          d="M327 106C329.761 106 332 103.761 332 101C332 98.2386 329.761 96 327 96C324.239 96 322 98.2386 322 101C322 103.761 324.239 106 327 106Z"
          stroke="#CCCCCC"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M198 121L191 142L177 131L182 117L185 113L198 121Z"
          fill="white"
          stroke="#A4A4A4"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M287.811 257.31L296.826 269.329C296.826 269.329 329.113 264.768 319.362 260.315C309.611 255.862 307.435 261.334 302.836 255.807C300.119 252.527 297.101 249.509 293.821 246.793L287.811 257.31Z"
          fill="#171717"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M266.275 240.778L281.3 260.31L306.841 248.29L276.793 197.208"
          fill="white"
        />
        <path
          d="M266.275 240.778L281.3 260.31L306.841 248.29L276.793 197.208"
          stroke="#A4A4A4"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M236.226 258.807L230.217 270.827C230.217 270.827 248.982 292.022 251.251 287.353C253.52 282.684 247.265 278.714 246.743 269.324C246.221 259.934 246.743 258.807 246.743 258.807"
          fill="#171717"
        />
        <path
          opacity="0.1"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M281 205C281 205 278.77 245.107 274 249L264 237"
          fill="#0D2344"
        />
        <path d="M30.394 338.436H354.918" stroke="#334EA5" stroke-width="2" />
        <path
          d="M28.8911 186.691C28.8911 186.691 37.1541 179.679 43.9151 194.203C50.6761 208.727 58.1881 215.237 60.4421 200.213C62.6961 185.189 64.1981 183.185 75.4661 194.203C86.7341 205.221 95.7491 206.222 102.51 197.203"
          stroke="#C2C2C2"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M53.6809 66.5C54.7208 66.5 55.7374 66.8084 56.602 67.3861C57.4667 67.9639 58.1406 68.7851 58.5386 69.7458C58.9366 70.7066 59.0407 71.7638 58.8378 72.7838C58.6349 73.8037 58.1342 74.7406 57.3988 75.476C56.6635 76.2113 55.7266 76.7121 54.7066 76.915C53.6867 77.1179 52.6295 77.0137 51.6687 76.6158C50.7079 76.2178 49.8867 75.5439 49.309 74.6792C48.7312 73.8145 48.4229 72.7979 48.4229 71.758C48.4229 70.3635 48.9768 69.0261 49.9629 68.04C50.9489 67.054 52.2863 66.5 53.6809 66.5Z"
          stroke="#C2C2C2"
        />
        <path
          d="M326.375 216.734C329.689 216.734 332.375 214.048 332.375 210.734C332.375 207.42 329.689 204.734 326.375 204.734C323.061 204.734 320.375 207.42 320.375 210.734C320.375 214.048 323.061 216.734 326.375 216.734Z"
          stroke="#C2C2C2"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M259.265 86.53L283.972 88.346C283.192 93.2057 280.939 97.709 277.518 101.248C274.097 104.786 269.672 107.19 264.841 108.134C260.011 109.078 255.007 108.517 250.505 106.527C246.004 104.536 242.221 101.213 239.669 97.0042C237.116 92.7958 235.916 87.9054 236.231 82.9935C236.547 78.0816 238.362 73.3847 241.431 69.5371C244.501 65.6895 248.677 62.8764 253.396 61.4778C258.115 60.0791 263.15 60.1623 267.82 61.716L259.265 86.53Z"
          fill="#AAB4C4"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M272.82 58.7159C278.26 60.4772 282.885 64.1366 285.851 69.0257C288.816 73.9149 289.924 79.7076 288.972 85.3459L264.265 83.5299L272.82 58.7159Z"
          fill="#334EA5"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M213 104C213 104 214.144 110.818 212 116C209.161 122.861 201.955 131.218 185 115C185 115 182.184 97.9811 190 97.0001C197.816 96.0191 213 104 213 104Z"
          fill="white"
          stroke="#A4A4A4"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M171.622 186.691C171.622 186.691 167.122 205.091 185.144 212.232H251.251L231.719 257.305L255.758 267.822C255.758 267.822 284.611 215.312 281.299 201.715C277.987 188.118 252.86 186.441 203.173 177.676C153.369 168.891 171.622 186.691 171.622 186.691Z"
          fill="white"
          stroke="#A4A4A4"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M211.521 167.935C215.337 173.817 239.334 174.535 248 179C260.1 185.233 253 176 253 176C241.684 171.542 229.963 168.193 218 166L205 156"
          fill="white"
        />
        <path
          d="M211.521 167.935C215.337 173.817 239.334 174.535 248 179C260.1 185.233 253 176 253 176C241.684 171.542 229.963 168.193 218 166L205 156"
          stroke="#A4A4A4"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M223.709 174.164L264.275 184.681L288.314 142.613L292.821 145.613L267.28 189.183L223.709 178.666V174.159V174.164Z"
          fill="#171717"
        />
        <path
          d="M184.297 96.938C187.775 96.938 190.594 94.1187 190.594 90.641C190.594 87.1633 187.775 84.344 184.297 84.344C180.819 84.344 178 87.1633 178 90.641C178 94.1187 180.819 96.938 184.297 96.938Z"
          fill="#171717"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M207.68 183.686C207.68 183.686 220.307 196.381 233.221 183.686C246.135 170.991 262.074 162.426 269.28 165.657C276.486 168.888 281.18 165.388 279.797 161.149C278.414 156.91 267.011 150.793 258.763 158.149C258.763 158.149 247.263 165.822 237.729 167.163C231.437 168.194 225.351 170.222 219.7 173.173L212.187 167.163L204.675 180.685L207.68 183.686Z"
          fill="white"
          stroke="#A4A4A4"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M116.032 242.281H168.617V336.934H116.032V242.281Z"
          fill="#334EA5"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M173.124 212.232H225.709V336.932H173.124V212.232Z"
          fill="#008037"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M198 177L206 186L217 167L206 161L198 177Z"
          fill="#AAB4C4"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M165 183C165 183 161.038 133 184 125C184 125 210.809 141.586 214.695 163.657C216.519 174.017 214.695 165.157 214.695 165.157L204.178 181.684L207 229L189 213C189 213 181.276 207.079 165 213C136.587 223.336 165 183 165 183Z"
          fill="#334EA5"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M221 104C221 104 210.109 113.331 200 103C200 103 201.632 109.426 199 110C199 110 193.012 102.136 193.3 109.133C193.582 116.043 183.738 118.318 185.967 119.466C185.967 119.466 183.027 132.247 178.002 133C172.977 133.753 162.777 144.5 164.002 162C165.227 179.5 157.002 171 157.002 171C157.002 171 161.277 172 157.002 157C152.727 142 158.193 128.015 170.002 118C179.727 109.753 181.002 95 181.002 95C181.002 95 201.917 71.417 221 104ZM167 139C167 139 161.817 154.164 165 162C168.183 169.836 176 131 176 131"
          fill="#171717"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M178 141V146L183 143L181 137L178 141Z"
          fill="#AAB4C4"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M180 150L175 155L179 157"
          fill="#AAB4C4"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M174 167L179 171L177 164"
          fill="#AAB4C4"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M167 179L165 187H171"
          fill="#AAB4C4"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M175 177L179 181L181 177"
          fill="#AAB4C4"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M193 151L187 162L191 160"
          fill="#AAB4C4"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M196 178L200 188L194 185"
          fill="#AAB4C4"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M168 204L178 198L180 202"
          fill="#AAB4C4"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M191 199L194 209L197 205"
          fill="#AAB4C4"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M205 158L200 165Z"
          fill="#AAB4C4"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M197 173L192 168L194 174"
          fill="#AAB4C4"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M166 195L162 199L165 200"
          fill="#AAB4C4"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M204 156V162L206 160"
          fill="#AAB4C4"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M210 166L206 173L208 174"
          fill="#AAB4C4"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M193 145L187 148L189 150"
          fill="#AAB4C4"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M186 166V170L188 172"
          fill="#AAB4C4"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M185 187L179.523 187.782L178 188L182 191"
          fill="#AAB4C4"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M197 195L201 197L198 191"
          fill="#AAB4C4"
        />
        <path
          opacity="0.13"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M202 207L252 213L190 212"
          fill="#0D2344"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M204 181C204 181 193.1 169.773 188 165C182.9 160.227 203 190 203 190L204 181Z"
          fill="#0D2344"
        />
      </svg>
    }
    <div class="right-bottom-logo">
      <svg
        width="113"
        height="68"
        viewBox="0 0 113 68"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <rect width="113" height="68" fill="url(#pattern0_239_842)" />
        <defs>
          <pattern
            id="pattern0_239_842"
            patternContentUnits="objectBoundingBox"
            width="1"
            height="1"
          >
            <use
              xlink:href="#image0_239_842"
              transform="matrix(0.00707965 0 0 0.0117647 -0.0769912 0)"
            />
          </pattern>
          <image
            id="image0_239_842"
            width="163"
            height="85"
            xlink:href="data:image/png;base64,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"
          />
        </defs>
      </svg>
    </div>
  </div>
</div>
